import isNumber from 'lodash/isNumber';
import React, {useMemo} from 'react';
import clsx from 'clsx';

import {Segmentation} from 'common/types/reports/query';
import {withStyles} from 'common/util/react';
import {SegmentValue} from 'common/query-builder/query-block/segment-menu/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {SelectTheme} from 'common/components/select/constants';
import {ButtonSize} from 'common/components/button/constants';
import {SelectReact} from 'common/components/select';

import {generateStepList, getStepLabel} from '../utils';
import css from './index.module.styl?inline';
import styles from './index.module.styl';

type Props = {
  className?: string;
  stepCount: number;
  selected: Segmentation;
  onChange: (selection: SegmentValue | Partial<PropertyFilter>) => void;
};

export const BehavioralStepSelectionSubItem = withStyles((props: Props) => {
  const selection = props.selected.behavior || props.selected;

  const sections = useMemo(() => {
    return generateStepList(selection, props.stepCount);
  }, [selection, props.stepCount]);

  const label = useMemo(() => {
    if (!sections[0]) return null;

    let startStepNumber = selection.startStepNumber;
    if (
      isNumber(selection.endStepNumber) &&
      sections[0].items.length <= selection.endStepNumber &&
      sections[0].items.some((item) => item.label === `All Steps`)
    ) {
      startStepNumber = null;
    }

    return getStepLabel(sections, startStepNumber);
  }, [selection, sections]);

  const isStepNumberValid = isNumber(selection.startStepNumber) || selection.startStepNumber === null;
  if (!isStepNumberValid) {
    return null;
  }

  return (
    <SelectReact
      className={clsx(styles.subitemSelect, props.className)}
      elref='stepSelect'
      disableSearch
      tabIndex={-1}
      theme={SelectTheme.QbSubitem}
      size={ButtonSize.Small}
      label={label}
      sections={sections}
      onChange={(ev) => {
        const startStepNumber = ev.detail.item.value;
        const endStepNumber = isNumber(startStepNumber) ? startStepNumber + 1 : null;

        if (props.selected.behavior) {
          props.onChange({
            ...props.selected,
            behavior: {
              ...props.selected.behavior,
              startStepNumber,
              endStepNumber,
            },
          });
        } else {
          props.onChange({
            ...props.selected,
            startStepNumber,
            endStepNumber,
          });
        }
      }}
    />
  );
}, css);
